import { render, staticRenderFns } from "./claim-update-requests-view.vue?vue&type=template&id=21f2e67d&"
import script from "./claim-update-requests-view.vue?vue&type=script&lang=ts&"
export * from "./claim-update-requests-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports